import { useEffect, useRef, useState } from 'react';
import { markSessionPresence, safeReturnPath, userManager } from './authClient';
import App from '../App';

/** Complete the redirect once and retain the in-memory session when entering the app. */
export function AuthCallback() {
  const [error, setError] = useState<string | null>(null);
  const [complete, setComplete] = useState(false);
  const callback = useRef<ReturnType<typeof userManager.signinCallback> | null>(null);

  useEffect(() => {
    let active = true;
    // React StrictMode replays effects; an authorization code/state can only be consumed once.
    callback.current ??= userManager.signinCallback();
    callback.current
      .then((user) => {
        // Silent/sign-out callbacks can return no user. The iframe sends its response to the
        // parent through oidc-client-ts and must not navigate or boot another application.
        if (!active || !user) return;
        markSessionPresence(true);
        const state = user.state as { returnTo?: unknown } | undefined;
        window.history.replaceState(null, '', safeReturnPath(state?.returnTo));
        setComplete(true);
      })
      .catch(() => {
        if (active) setError('Unable to complete sign-in. Please return to PeruseLab and try again.');
      });
    return () => {
      active = false;
    };
  }, []);

  if (complete) return <App />;
  return (
    <main className="auth-callback">
      {error ? (
        <>
          <p className="import-error" role="alert">
            {error}
          </p>
          <a href="/">Return to PeruseLab</a>
        </>
      ) : (
        <p>Signing in…</p>
      )}
    </main>
  );
}
